import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.907 6.52051C10.3389 6.52051 9.06775 7.79168 9.06775 9.35975C9.06775 10.5444 9.7933 11.5596 10.8243 11.9853C10.8242 11.9853 10.8242 11.9853 10.8241 11.9853C11.1578 12.1231 11.5235 12.1991 11.9069 12.1991C12.2905 12.1991 12.6562 12.1231 12.9899 11.9852C12.9899 11.9852 12.9898 11.9852 12.9898 11.9852C14.0207 11.5596 14.7462 10.5444 14.7462 9.35975C14.7462 7.79168 13.4751 6.52051 11.907 6.52051ZM7.52051 16.2372C7.52051 14.6531 8.36017 13.2651 9.61871 12.4941C10.2603 12.9633 11.0513 13.2402 11.9069 13.2402C12.7627 13.2402 13.5538 12.9632 14.1954 12.494C15.454 13.265 16.2937 14.653 16.2937 16.2372V16.4975H7.52051V16.2372Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
